import { Reveal } from "./Reveal";

export const SectionHeading = ({ index, eyebrow, title, action, className = "", testId }) => (
  <Reveal className={`flex flex-col gap-8 md:flex-row md:items-end md:justify-between ${className}`}>
    <div data-testid={testId}>
      <p className="eyebrow flex items-center gap-4 opacity-55">
        {index && <span className="tabular-nums">{index}</span>}
        {index && <span className="h-px w-8 bg-current" aria-hidden />}
        {eyebrow}
      </p>
      <h2 className="h-section font-display mt-5">{title}</h2>
    </div>
    {action}
  </Reveal>
);
